import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import { set, toggle } from './vuex'
import time from './modules/time'
import settings from './modules/settings'
import users from './modules/users'
import orders from './modules/orders'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    time,
    settings,
    users,
    orders,
  },
  state: {
    appName: 'TSB Living Pickups',
    showSpinner: false,
    showSnackbar: false,
    snackbarText: '',
    snackbarIsError: false,
  },
  mutations: {
    toggleDrawer: toggle('drawer'),
    showSpinner: set('showSpinner'),
    showSnackbar: set('showSnackbar'),
    snackbarText: set('snackbarText'),
    snackbarIsError: set('snackbarIsError'),
  },
  actions: {},
  getters: {},
})
